"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = require("@tencent/vft-common/logger");
exports.default = new logger_1.Logger('wetv-commom');
